import React, { useState, useEffect } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";

const ResultItem = ({ result, image }) => {
  const [match, setMatch] = useState();
  const [rank, setRank] = useState();
  const [product, setProduct] = useState();
  const [total, setTotal] = useState();

  useEffect(() => {
    const findMatch = async (tpnb) => {
      if (tpnb[0] === "0") tpnb = tpnb.slice(1);
      let index;
      const m = await _.find(result.results, (o, i) => {
        index = i;
        return o.tpnb.toString() === tpnb;
      });
      if (m) return { m, index };
      throw new Error("No match");
    };

    setTotal(result.results.length);

    findMatch(result.tpnb)
      .then((data) => {
        setMatch(data.m.name);
        setRank(data.index + 1);
        setProduct(data.m);
      })
      .catch((error) => {
        setMatch(error.message);
        setRank();
        setProduct();
      });
  }, [result]);

  return (
    <Table.Row>
      <Table.Cell>{result.query}</Table.Cell>
      <Table.Cell>
        {product && (
          <>
            <a
              href={`https://www.tesco.com/groceries/en-GB/products/${product.id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {image && <img className="sku-thumb" src={image} alt={match} />}
            </a>{" "}
            {match}
          </>
        )}
        {!product && match}
      </Table.Cell>
      <Table.Cell>{total}</Table.Cell>
      <Table.Cell>{rank}</Table.Cell>
    </Table.Row>
  );
};

export default ResultItem;
